import { FunctionComponent } from 'react';

import { Text } from '@/atoms';

import { TypeNutritionalValueProps } from './types';

/**
 * NutritionalValue
 */
export const NutritionalValue: FunctionComponent<TypeNutritionalValueProps> = ({
  className = '',
  name,
  value,
}: TypeNutritionalValueProps) => (
  <div className={className}>
    <Text className="text-caption text-caption--s text-secondary-800 mb-2">
      {name}
    </Text>
    <Text className="text-body text-body--l">{value}</Text>
  </div>
);

NutritionalValue.displayName = 'NutritionalValue';
